import { studentDisplayName } from './student-roster.ts';

const NAME_HEADERS = new Set(['eleve', 'élève', 'nom complet', 'nom et prenom', 'nom et prénom']);
const FIRST_NAME_HEADERS = new Set(['prenom', 'prénom', 'first name', 'firstname']);
const LAST_NAME_HEADERS = new Set(['nom', 'last name', 'lastname']);

function cells(line: string): string[] {
  const separator = line.includes(';') ? ';' : line.includes('\t') ? '\t' : line.includes(',') ? ',' : '';
  if (!separator) return [line.trim()];

  const result: string[] = [];
  let value = '';
  let quoted = false;
  for (let index = 0; index < line.length; index += 1) {
    const character = line[index]!;
    if (character === '"') {
      if (quoted && line[index + 1] === '"') {
        value += '"';
        index += 1;
      } else {
        quoted = !quoted;
      }
    } else if (character === separator && !quoted) {
      result.push(value.trim());
      value = '';
    } else {
      value += character;
    }
  }
  result.push(value.trim());
  return result;
}

function header(value: string): string {
  return value.replace(/^\ufeff/, '').trim().toLocaleLowerCase('fr');
}

/** Read the usual TXT/CSV class lists without requiring a spreadsheet library. */
export function studentNamesFromText(text: string): string[] {
  const rows = text.split(/\r?\n/).map(cells).filter((row) => row.some(Boolean));
  if (!rows.length) return [];

  const headings = rows[0]!.map(header);
  const fullNameIndex = headings.findIndex((value) => NAME_HEADERS.has(value));
  const firstNameIndex = headings.findIndex((value) => FIRST_NAME_HEADERS.has(value));
  const lastNameIndex = headings.findIndex((value) => LAST_NAME_HEADERS.has(value));
  const hasHeader = fullNameIndex >= 0 || firstNameIndex >= 0 || lastNameIndex >= 0;

  return rows.slice(hasHeader ? 1 : 0).map((row) => {
    // School lists come numbered; the app numbers the class itself, so the
    // number is dropped here rather than ending up inside the name.
    if (fullNameIndex >= 0) return studentDisplayName(row[fullNameIndex]?.trim() ?? '');
    if (firstNameIndex >= 0 || lastNameIndex >= 0) {
      return [row[firstNameIndex]?.trim(), row[lastNameIndex]?.trim()].filter(Boolean).join(' ');
    }
    return studentDisplayName(row.filter(Boolean).join(' ').trim());
  }).filter(Boolean);
}
